import { render, staticRenderFns } from "./Visa.vue?vue&type=template&id=18620d9e"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18620d9e')) {
      api.createRecord('18620d9e', component.options)
    } else {
      api.reload('18620d9e', component.options)
    }
    module.hot.accept("./Visa.vue?vue&type=template&id=18620d9e", function () {
      api.rerender('18620d9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/paymentCards/Visa.vue"
export default component.exports